import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeComponent } from "./home.component";
import { BannerComponent } from "./banner/banner.component";
import { StepsComponent } from "./steps/steps.component";
import { CardTypeComponent } from "./card-type/card-type.component";
import { FeaturesComponent } from "./features/features.component";
import { DemoComponent } from "./demo/demo.component";
import { FaqComponent } from "./faq/faq.component";
import { CarouselModule } from "ngx-owl-carousel-o";
import { SharedModule } from "src/app/shared/shared.module";
import { SharedWebModule } from '../shared/shared.web.module';
import { LogMenuComponent } from './log-menu/log-menu.component';

@NgModule({
  declarations: [
    HomeComponent,
    BannerComponent,
    StepsComponent,
    CardTypeComponent,
    FeaturesComponent,
    DemoComponent,
    FaqComponent,
    LogMenuComponent,
  ],
  imports: [CommonModule, CarouselModule, SharedModule, SharedWebModule],
  exports: [HomeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeModule { }
